import React, { useState } from 'react';
import gql from 'graphql-tag';
import { Input, Button, Text, Disclaimer } from 'design-system';
import { Form, Responsive } from 'UI';
import { useMail, useMutation } from 'hooks';
import './Newsletter.scss';
import classNames from 'classnames';
import { GraphqlShield } from 'utils';
import { mdiAlertCircleOutline } from '@mdi/js';

const SET_NEWSLETTER_SUBSCRIPTION = gql`
  mutation setNewsletterSubscription(
    $newsletter: Boolean!
    $email: EmailAddress
  ) {
    setNewsletterSubscription(newsletter: $newsletter, email: $email)
  }
`;

const errorConfig = [
  {
    error: 'email must be a valid email',
    userLabel: 'Email invalide',
  },
];

function Newsletter({ errors, withLogo = false }) {
  const emailPlaceholder = useMail();
  const [email, setEmail] = useState('');
  const [validated, setValidated] = useState(false);

  const [newsletterSignup] = useMutation(SET_NEWSLETTER_SUBSCRIPTION);

  async function handleSubmit(e) {
    e.preventDefault();
    await newsletterSignup({
      variables: {
        newsletter: true,
        email: email,
      },
    });
    setValidated(true);
  }

  function ErrorDisclaimer() {
    if (validated) return null;
    return errors.map(error => {
      const errorInfo = errorConfig.find(config =>
        error.includes(config.error)
      );
      return (
        <Disclaimer
          className="error-disclaimer"
          type="danger"
          size="large"
          icon={mdiAlertCircleOutline}
          text={errorInfo?.userLabel || 'Une erreur est survenue'}
        />
      );
    });
  }
  return (
    <div id="Newsletter">
      <form onSubmit={handleSubmit}>
        <Form
          withLogo={withLogo}
          className={classNames('nl-form', {
            validated: validated,
          })}
        >
          <Responsive>
            <Text bold>
              {validated
                ? 'Inscription validée !'
                : 'Inscris toi à la Newsletter Mangas.io !'}
            </Text>
          </Responsive>
          <ErrorDisclaimer />
          <div className="nl-inputs">
            {!validated && (
              <>
                <Input
                  className="nl-input"
                  onChange={e => setEmail(e.target.value)}
                  label="E-mail"
                  type="email"
                  field="email"
                  placeholder={emailPlaceholder}
                  required
                />
                <Button
                  className="nl-btn"
                  type="submit"
                  variant="secondary"
                  label="Je m'inscris"
                  disabled={email ? false : true}
                />
              </>
            )}
          </div>
        </Form>
      </form>
    </div>
  );
}

function ShieldedNewsletter(props) {
  return (
    <GraphqlShield>
      {(errors = []) => <Newsletter {...props} errors={errors} />}
    </GraphqlShield>
  );
}

export default ShieldedNewsletter;
